import '@fontsource/poppins/700.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/500-italic.css';

export const FONT_WEIGHT = {
  bolder: '700',
  bold: '600',
  normal: '500',
  light: '400',
  lighter: '300',
  ultraLight: '200',
  thin: '100',
} as const;

export const fontFamily = 'Poppins, sans-serif';
